module.exports = __webpack_public_path__ + "img/locked.d734237c.svg";